module.exports = __webpack_public_path__ + "static/media/ForgotPassword.010025f8.png";